export default __webpack_public_path__ + "static/media/subtract.82e83f24.svg";